import { forwardRef } from "react";

import { SxProps, Theme, Box } from "@mui/material";

import { DashboardTooltip, DashboardTooltipProps } from "./DashboardTooltip";

import { mergeSx } from "@/common/helpers/mergeSx";
import { DashboardIcon, DashboardIconProps } from "@/dashboard-design-system/Icon/DashboardIcon";
import { Info as InfoIcon } from "@/icons/outlined";

export type DashboardInformationTooltipProps = Omit<DashboardTooltipProps, "children" | "disabled"> & {
  alignOnText?: boolean;
  alignOffset?: string;
  slotProps?: DashboardTooltipProps["slotProps"] & {
    icon?: Omit<DashboardIconProps, "ref" | "children">;
  };
  sx?: SxProps<Theme>;
};

export const DashboardInformationTooltip = forwardRef<HTMLDivElement, DashboardInformationTooltipProps>(
  ({ alignOnText = false, alignOffset, slotProps, sx, ...rest }, ref) => {
    const { icon: iconProps, ...tooltipProps } = slotProps ?? {};

    const styles = mergeSx(
      {
        display: "inline-flex",
        cursor: "help",
        ...(alignOnText && {
          position: "relative",
          top: alignOffset || "0.25rem",
        }),
      },
      sx
    );

    return (
      <Box sx={styles}>
        <DashboardTooltip {...rest} ref={ref} slotProps={tooltipProps}>
          <DashboardIcon vibe="text-neutral-moderate" size="small" {...(iconProps ?? {})}>
            <InfoIcon />
          </DashboardIcon>
        </DashboardTooltip>
      </Box>
    );
  }
);

DashboardInformationTooltip.displayName = "DashboardInformationTooltip";
